import axios from "../lib/axios";

// สมัครสมาชิก
export const register = async (username, password) => {
  try {
    const response = await axios.post("/auth/register", { username, password });

    // บันทึก token และ username ทันทีหลังสมัคร
    const { token, username: savedUsername } = response.data;
    localStorage.setItem("access_token", token);
    localStorage.setItem("username", savedUsername);

    return response.data;
  } catch (error) {
    console.error("Register error:", error.response?.data || error.message);
    throw error;
  }
};

// เข้าสู่ระบบ
export const login = async (username, password) => {
  try {
    const response = await axios.post("/auth/login", { username, password });

    const { token, username: savedUsername } = response.data;
    localStorage.setItem("access_token", token);
    localStorage.setItem("username", savedUsername);

    return response.data;
  } catch (error) {
    console.error("Login error:", error.response?.data || error.message);
    throw error;
  }
};

// ออกจากระบบ
export const logout = async () => {
  try {
    await axios.post("/auth/logout");
  } catch (error) {
    console.warn("Logout API failed:", error.response?.data || error.message);
  } finally {
    localStorage.removeItem("access_token");
    localStorage.removeItem("username");
  }
};

// เช็ค session ว่ายัง valid หรือไม่
export const checkSession = async () => {
  try {
    await axios.get("/auth/check-session"); // ต้องมี route ฝั่ง backend
    return true; // ยัง valid
  } catch (error) {
    if (error.response?.status === 401) {
      return false; // หมด session
    }
    throw error; // error อื่นๆ
  }
};

// เพิ่มฟังก์ชันเปลี่ยนรหัสผ่าน
export const changePassword = async (oldPassword, newPassword) => {
  const response = await axios.post("/auth/change-password", {
    currentPassword: oldPassword,
    newPassword,
  });
  return response.data;
};
